import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Row,
  Typography,
  List,
  Tooltip,
  Flex,
  Modal,
  Divider,
  Popconfirm,
  Skeleton,
  Form,
  Input,
  Space,
  message,
} from "antd";
import { useEffect, useState, useContext } from "react";
import { IndexContext } from "../../../context/IndexContext";
import useFetch from "../../../hooks/useFetch";
import "../../../styles/Configuration/SiteView.css";
// import TelegramGroupForm from "./TelegramGroupForm";
// import telegramGroups from "./telegramGroups";

const { Text, Title } = Typography;

export default function TelegramView(props) {
  const { siteID } = props;

  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);

  const [fetchWrapper] = useFetch();
  const [form] = Form.useForm();

  const [newModalOpen, setNewModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedInfoTelegramGroup, setSelectedInfoTelegramGroup] =
    useState(null);

  const [telegramGroups, setTelegramGroups] = useState([]);
  const [selectedEditTelegramGroup, setSelectedEditTelegramGroup] =
    useState(null); // this selected ser is the seu to be edited

  // load index context
  const { messageApi, notificationApi } = useContext(IndexContext);

  /* API to get seu details */
  function getTelegramGroups() {
    setLoading(true);
    fetchWrapper({
      endpoint_url: "site_management/getTelegramGroups",
      method: "GET",
      params: {
        SiteID: siteID,
      },
      onSuccess: (response) => {
        setTelegramGroups(response.data);
      },
      onResponseError: (response) => {
        notificationApi.error({
          message: response.message,
        });
      },
      onFetchError: (error) => {},
      onFinish: () => {
        setLoading(false);
      },
    });
  }

  function onSubmitNewTelegramGroup() {
    setFormLoading(true);
    fetchWrapper({
      endpoint_url: "site_management/addTelegramGroup",
      body: {
        siteID: siteID,
        ...form.getFieldsValue(),
      },
      onSuccess: (response) => {
        notificationApi.success({
          message: response.message,
        });
        getTelegramGroups();
        setNewModalOpen(false);
      },
      onResponseError: (response) => {
        notificationApi.error({
          message: response.message,
        });
      },
      onFinish: () => setFormLoading(false),
    });
  }

  function onSubmitEditTelegramGroup(value) {
    setFormLoading(true);
    fetchWrapper({
      endpoint_url: "site_management/editTelegramGroup",
      method: "PUT",
      params: { ID: selectedEditTelegramGroup.ID },
      body: {
        name: value.name.trim(),
        chatID: value.chatID.trim(),
      },
      onSuccess: (response) => {
        notificationApi.success({
          message: response.message,
        });
        getTelegramGroups();
        setEditModalOpen(false);
        setSelectedEditTelegramGroup(null);
      },
      onResponseError: (response) => {
        notificationApi.error({
          message: response.message,
        });
      },
      onFinish: () => setFormLoading(false),
    });
  }

  /* API to check whether site name is unique */
  function checkUniqueName(SiteID, Name, ID, callback) {
    fetchWrapper({
      endpoint_url: "site_management/checkUniqueTelegramGroupName",
      body: {
        SiteID: SiteID,
        Name: Name,
        ID: ID,
      },
      onSuccess: (response) => {
        if (!response.data) {
          callback(response.message);
        } else {
          callback();
        }
      },
    });
  }

  /* API to delete seu */
  function deleteTelegram(telegramID) {
    fetchWrapper({
      endpoint_url: "site_management/deleteTelegramGroup",
      method: "DELETE",
      params: { ID: telegramID },
      onSuccess: (response) => {
        notificationApi.success({
          message: response.message,
        });
        getTelegramGroups();
        setSelectedInfoTelegramGroup(null);
      },
      onResponseError: (response) => {
        notificationApi.error({
          message: response.message,
        });
        getTelegramGroups();
        setSelectedInfoTelegramGroup(null);
      },
    });
  }

  useEffect(() => {
    getTelegramGroups();
  }, [siteID]);

  return (
    <div className="list-view" style={{ height: "100%" }}>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={10} xl={10}>
          <div className="mb-2">
            <Title level={3} className="mt-0">
              Telegram Group
            </Title>
            <Button
              icon={<PlusOutlined />}
              className="mb-5"
              style={{ width: "100%" }}
              onClick={() => setNewModalOpen(true)}
            >
              New Telegram Group
            </Button>

            {loading ? (
              <Skeleton />
            ) : (
              <List
                dataSource={telegramGroups}
                size="large"
                renderItem={(item) => (
                  <List.Item
                    className={
                      selectedInfoTelegramGroup?.ID == item.ID
                        ? "ant-list-item list-item-selected"
                        : "ant-list-item list-item"
                    }
                    onClick={() => {
                      setSelectedInfoTelegramGroup(item);
                    }}
                  >
                    <Flex
                      justify="space-between"
                      style={{
                        width: "100%",
                      }}
                    >
                      <div>{item.Name}</div>

                      <Flex gap={8}>
                        <div className="mr-2">
                          <Tooltip title="Edit">
                            <EditOutlined
                              onClick={() => {
                                setSelectedEditTelegramGroup(item);
                                // form.setFieldsValue({
                                //   name: item.Name,
                                //   chatID: item.ChatID,
                                // });
                                setEditModalOpen(true);
                              }}
                              style={{
                                color:
                                  selectedInfoTelegramGroup?.ID == item.ID
                                    ? "var(--ant-color-white)"
                                    : "var(--ant-color-primary)",
                              }}
                            />
                          </Tooltip>
                        </div>

                        <div>
                          <Tooltip title="Delete">
                            <Popconfirm
                              title="Delete Telegram Group"
                              description={
                                "Are you sure to delete this telegram group?"
                              }
                              onConfirm={() => {
                                deleteTelegram(item.ID);
                              }}
                              okText="Yes"
                              cancelText="No"
                            >
                              <DeleteOutlined
                                style={{ color: "var(--ant-color-error)" }}
                              />
                            </Popconfirm>
                          </Tooltip>
                        </div>
                      </Flex>
                    </Flex>
                  </List.Item>
                )}
              />
            )}
          </div>
        </Col>

        <Col xs={24} sm={24} md={24} lg={10} xl={10}>
          {/* <telegramGroups selectedTelegramGroup={selectedInfoTelegramGroup} /> */}
        </Col>
      </Row>

      {/* New Telegram Group Form */}
      <Modal
        title="New Telegram Group"
        open={newModalOpen}
        footer={null}
        destroyOnClose={true}
        closable={false}
        maskClosable={false}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmitNewTelegramGroup}
          clearOnDestroy
          className={"mt-5"}
        >
          <Divider className="mb-4 mt-0"></Divider>
          <Form.Item
            name={"name"}
            label={"Name"}
            getValueProps={(value) => value && value.trim()}
            normalize={(value) => value && value.trim()}
            validateDebounce={200}
            validateTrigger={["onBlur", "onChange"]}
            rules={[
              { required: true, message: "Name is required" },
              {
                validator: (_, value, callback) => {
                  checkUniqueName(siteID, value.trim(), null, callback); // Check if site name is unique if mode is "add"
                },
              },
            ]}
          >
            <Input maxLength={50}></Input>
          </Form.Item>
          <Form.Item
            name={"chatID"}
            getValueProps={(value) => value && value.trim()}
            normalize={(value) => value && value.trim()}
            label={
              <Space>
                Chat ID
                <Tooltip
                  placement="rightTop"
                  title={
                    <>
                      Enter{" "}
                      <Text strong italic>
                        /ChatID
                      </Text>{" "}
                      command in telegram group to get ChatID
                    </>
                  }
                >
                  <InfoCircleOutlined />
                </Tooltip>
              </Space>
            }
            rules={[{ required: true, message: "Chat ID is required" }]}
          >
            <Input maxLength={50}></Input>
          </Form.Item>
          <Flex justify="end" align="center" gap="middle">
            <Button
              disabled={formLoading}
              type="default"
              onClick={() => {
                setNewModalOpen(false);
              }}
            >
              Cancel
            </Button>
            <Button htmlType="submit" loading={formLoading} type="primary">
              Submit
            </Button>
          </Flex>
        </Form>
      </Modal>

      <Modal
        title="Edit Telegram Group"
        open={editModalOpen}
        footer={null}
        closable={false}
        destroyOnClose={true}
        maskClosable={false}
      >
        {selectedEditTelegramGroup != null ? (
          <Form
            form={form}
            layout="vertical"
            onFinish={onSubmitEditTelegramGroup}
            clearOnDestroy
            className={"mt-5"}
          >
            <Divider className="mb-4 mt-0"></Divider>
            <Form.Item
              name={"name"}
              label={"Name"}
              getValueFromEvent={(e) => {
                return e.target.value.trimStart();
              }}
              validateDebounce={200}
              validateTrigger={["onBlur", "onChange"]}
              normalize={(value) => value && value.trimStart()}
              rules={[
                { required: true, message: "Name is required" },
                { max: 50 },
                {
                  validator: (_, value, callback) => {
                    checkUniqueName(
                      siteID,
                      value.trim(),
                      selectedEditTelegramGroup.ID,
                      callback
                    ); // Check if site name is unique if mode is "add"
                  },
                },
              ]}
              initialValue={selectedEditTelegramGroup.Name}
            >
              <Input
                count={{ max: 50, strategy: (value) => value?.trim().length }}
              ></Input>
            </Form.Item>
            <Form.Item
              name={"chatID"}
              label={
                <Space>
                  Chat ID
                  <Tooltip
                    placement="rightTop"
                    title={
                      <>
                        Enter{" "}
                        <Text
                          strong
                          italic
                          style={{ color: "var(--ant-color-primary)" }}
                        >
                          /ChatID
                        </Text>{" "}
                        command in telegram group to get ChatID
                      </>
                    }
                  >
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              getValueFromEvent={(e) => {
                return e.target.value.trimStart();
              }}
              normalize={(value) => value && value.trimStart()}
              rules={[
                { required: true, message: "Chat ID is required" },
                { max: 50 },
              ]}
              initialValue={selectedEditTelegramGroup.ChatID}
            >
              <Input
                count={{
                  max: 50,
                  strategy: (value) => {
                    return value?.trim().length;
                  },
                }}
              ></Input>
            </Form.Item>
            <Flex justify="end" align="center" gap="middle">
              <Button
                disabled={formLoading}
                type="default"
                onClick={() => {
                  setEditModalOpen(false);
                  setSelectedEditTelegramGroup(null);
                }}
              >
                Cancel
              </Button>
              <Button htmlType="submit" loading={formLoading} type="primary">
                Submit
              </Button>
            </Flex>
          </Form>
        ) : (
          <></>
        )}
      </Modal>
    </div>
  );
}
